import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const EffectModeIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Sparkle/effect icon - multiple sparkles representing visual effects */}
      {/* Main large sparkle */}
      <path
        d="M12 3v4M12 17v4M3 12h4M17 12h4"
        stroke={color}
        strokeWidth={strokeWidth * 1.2}
        strokeLinecap="round"
      />
      <path
        d="M6.5 6.5l2.5 2.5M15 15l2.5 2.5M6.5 17.5l2.5-2.5M15 9l2.5-2.5"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      {/* Center filled */}
      <circle cx="12" cy="12" r="2" fill={color} />
      {/* Small accent sparkle */}
      <circle cx="18" cy="6" r="1" fill={color} opacity="0.6" />
      <path d="M18 4v1M18 7v1M16 6h1M19 6h1" stroke={color} strokeWidth={strokeWidth * 0.6} strokeLinecap="round" opacity="0.6" />
    </BaseIcon>
  ),
);

EffectModeIcon.displayName = 'EffectModeIcon';
